// Email regex taken from the legacy Zoopla repo, to
// match (a) the rule used by the existing registration form
// and (b) the rules used by the back-end which eventually process registration.
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const PASSWORD_MIN_LENGTH = 8;
